<div
  [pTooltip]="content"
  [tooltipPosition]="position"
  [escape]="false"
  [tooltipOptions]="tooltipOptions"
  class="{{ styleClass }}"
  tooltipStyleClass="m-tooltip">
  <ng-content></ng-content>
</div>
